const accommodationDetailsKeys = [
  "roomType",
  "duration",
  "custom_duration",
  "inventory_id",
  "arrival_date",
  "moveOutDate",
  "tenancyId",
];
const personalDetailsKeys = [
  "data/title",
  "user_details/name",
  "data/dob",
  "data/gender",
  "user_details/phone_code",
  "user_details/phone",
  "user_details/email",
  "data/alternate_email",
  "data/nationality",
  "data/home_address/addr_line1",
  "data/home_address/addr_line2",
  "data/home_address/country",
  "data/home_address/state",
  "data/home_address/city",
  "data/home_address/postal",
  "data/medical_condition",
  "data/medical_condition_value",
  "universityDetailsSection",
  "data/university",
  "data/course",
  "data/enrolment_status",
  "data/pet",
  "data/parking",
  "data/major_subject",
  "data/residence_type",
  "data/previous_school",
];

const emergencyDetailsKeys = [
  "data/emergency_details/title",
  "data/emergency_details/name",
  "data/emergency_details/dob",
  "data/emergency_details/email",
  "data/emergency_details/phone_code",
  "data/emergency_details/phone",
  "data/emergency_details/relation",
  "data/emergency_details/address/same_as_home",
  "data/emergency_details/address/addr_line1",
  "data/emergency_details/address/addr_line2",
  "data/emergency_details/address/country",
  "data/emergency_details/address/state",
  "data/emergency_details/address/city",
  "data/emergency_details/address/postal",
];

const guarantorDetailsKeys = [
  "data/guarantor_details/same_as_emergency",
  "data/guarantor_details/title",
  "data/guarantor_details/name",
  "data/guarantor_details/dob",
  "data/guarantor_details/email",
  "data/guarantor_details/phone_code",
  "data/guarantor_details/phone",
  "data/guarantor_details/relation",
  "data/guarantor_details/guarantor_annual_income",
  "data/guarantor_details/address/same_as_personal",
  "data/guarantor_details/address/addr_line1",
  "data/guarantor_details/address/addr_line2",
  "data/guarantor_details/address/country",
  "data/guarantor_details/address/state",
  "data/guarantor_details/address/city",
  "data/guarantor_details/address/postal",
  "data/guarantor_details/guarantor_employer_name",
  "data/guarantor_details/guarantor_employer_phone",
  "data/guarantor_details/guarantor_employer_country",
  "data/guarantor_details/guarantor_employer_postal",
  "data/guarantor_details/guarantor_employer_city",
  "data/guarantor_details/guarantor_employer_state",
];

const additionalDetailsKeys = [
  "data/additional_details/apartment_eviction",
  "data/additional_details/criminal_charges",
  "data/additional_details/unpaid_dues",
  "data/additional_details/rentor_insurance",
  "data/additional_details/bankruptcy_status",
  "data/additional_details/smoking_preference_own",
  "data/additional_details/drinking_preference",
  "data/additional_details/cooking_preference",
  "data/additional_details/staying_preference",
  "data/additional_details/music_preference",
  "data/additional_details/fun_preference",
  "data/additional_details/friends_visit_preference",
  "data/additional_details/work_preference",
  "data/additional_details/living_arrangements",
  "data/additional_details/smoking_preference_others",
  "data/additional_details/cleanliness_preference",
  "data/additional_details/personality_type",
  "data/additional_details/pet_allergy",
  "data/additional_details/wakeup_preference",
  "data/additional_details/vaping_preference",
  "data/additional_details/guest_visits",
];

const roommateDetailsKeys = ["alreadyHaveRoommate", "roommateEntries"];

export {
  accommodationDetailsKeys,
  personalDetailsKeys,
  emergencyDetailsKeys,
  guarantorDetailsKeys,
  roommateDetailsKeys,
  additionalDetailsKeys,
};
